<a
  [ngClass]="['support-documentation__callout-card', large ? 'large' : '', disabled ? 'card-disabled' : '']"
  [target]="target"
  [href]="url"
  *ngIf="url">
  <ng-container *ngTemplateOutlet="calloutContent"></ng-container>
</a>
<a
  [ngClass]="['support-documentation__callout-card', large ? 'large' : '', disabled ? 'card-disabled' : '']"
  [target]="target"
  [routerLink]="route"
  *ngIf="!url">
  <ng-container *ngTemplateOutlet="calloutContent"></ng-container>
</a>

<ng-template #calloutContent>
  <div [ngClass]="['icon', green ? 'green' : '', orange ? 'orange' : '', grape ? 'grape' : '', aqua ? 'aqua' : '']">
    <sbnb-support-documentation-icon [icon]="icon"></sbnb-support-documentation-icon>
  </div>

  <div class="content">
    <div class="title">{{ title }}</div>
    <div class="body">
      <ng-content></ng-content>
    </div>
  </div>

  <ng-content select="[extra]"></ng-content>
</ng-template>
